import {
	BoundDynamicVariable,
	BoundStaticVariable,
	TemplateVariable,
} from '../models/dynamic-variable.model';

// ---------------------------------------------------------------------------
// Bound Static Variables (built-in, value from runtime data, no UI field)
// ---------------------------------------------------------------------------

export const BOUND_STATIC_VARIABLES: BoundStaticVariable[] = [
	{
		kind: 'bound-static', name: 'patientId', builtIn: true,
		shortLabel: { de: 'Patienten-ID', en: 'Patient ID' },
		label: { de: 'Die eindeutige Patientenkennung', en: 'The unique patient identifier' },
	},
	{
		kind: 'bound-static', name: 'patientName', builtIn: true,
		shortLabel: { de: 'Patientenname', en: 'Patient Name' },
		label: { de: 'Vollständiger Name des Patienten', en: 'Full name of the patient' },
	},
	{
		kind: 'bound-static', name: 'customerId', builtIn: true,
		shortLabel: { de: 'Kunden-ID', en: 'Customer ID' },
		label: { de: 'Die WMS-Kundenkennung', en: 'The WMS customer identifier' },
	},
	{
		kind: 'bound-static', name: 'customerName', builtIn: true,
		shortLabel: { de: 'Kundenname', en: 'Customer Name' },
		label: { de: 'Name des Kunden (Praxis)', en: 'Name of the customer (practice)' },
	},
	{
		kind: 'bound-static', name: 'productName', builtIn: true,
		shortLabel: { de: 'Produktname', en: 'Product Name' },
		label: { de: 'Name des bestellten Produkts', en: 'Name of the ordered product' },
	},
];

// ---------------------------------------------------------------------------
// Bound Dynamic Variables (built-in, value from runtime data, UI override field)
// ---------------------------------------------------------------------------

export const BOUND_DYNAMIC_VARIABLES: BoundDynamicVariable[] = [
	{
		kind: 'bound-dynamic', name: 'deadline', builtIn: true,
		shortLabel: { de: 'Fälligkeitsdatum', en: 'Deadline' },
		label: { de: 'Fälligkeitsdatum für die Rückmeldung', en: 'Deadline for the response' },
	},
	{
		kind: 'bound-dynamic', name: 'date', builtIn: true,
		shortLabel: { de: 'Datum', en: 'Date' },
		label: { de: 'Allgemeine DD.MM.YYYY Datumseingabe', en: 'General DD.MM.YYYY date input' },
	},
	{
		kind: 'bound-dynamic', name: 'monthYear', builtIn: true,
		shortLabel: { de: 'Monat und Jahr', en: 'Month and Year' },
		label: { de: 'Monat und Jahr Datumseingabe', en: 'Month and Year date input' },
	},
	{
		kind: 'bound-dynamic', name: 'webviewerLink-1', builtIn: true,
		shortLabel: { de: 'Webviewer-Link 1', en: 'Webviewer Link 1' },
		label: { de: 'Link zum neuesten Webviewer', en: 'Link to the latest webviewer' },
	},
	{
		kind: 'bound-dynamic', name: 'webviewerLink-2', builtIn: true,
		shortLabel: { de: 'Webviewer-Link 2', en: 'Webviewer Link 2' },
		label: { de: 'Link zum zweitjüngsten Webviewer', en: 'Link to the second-to-last webviewer' },
	},
	{
		kind: 'bound-dynamic', name: 'productAlternativeName', builtIn: true,
		shortLabel: { de: 'Alternativprodukt', en: 'Alternative Product' },
		label: { de: 'Name der alternativen Produktoption', en: 'Name of the alternative product option' },
	},
];

// ---------------------------------------------------------------------------
// Combined built-in list
// ---------------------------------------------------------------------------

export const BUILT_IN_VARIABLES: TemplateVariable[] = [
	...BOUND_STATIC_VARIABLES,
	...BOUND_DYNAMIC_VARIABLES,
];

export const BUILT_IN_VARIABLE_NAMES: string[] = BUILT_IN_VARIABLES.map(v => v.name);

export const VARIABLE_PATTERN = /\{\{([\w-]+)\}\}/g;
